<template>
  <div class="pcm-b-wrapper" id="pcm-b-wrapper">
    <img class="pcm-b-bg" src="@/assets/images/pc/pageB/bg.webp" alt="" />
    <img
      v-for="(item, index) in overlaySlides"
      :key="item"
      class="pcm-b-slide"
      :class="[
        `pcm-b-slide-${index + 2}`,
        { active: activeIndex === index + 1 }
      ]"
      :src="item"
      alt=""
    />

    <img
      class="pcm-b-preview pcm-b-preview-1"
      src="@/assets/images/pc/pageB/preview1.webp"
      alt=""
    />
    <img
      class="pcm-b-preview pcm-b-preview-2"
      src="@/assets/images/pc/pageB/preview2.webp"
      alt=""
    />
    <img
      class="pcm-b-preview pcm-b-preview-3"
      src="@/assets/images/pc/pageB/preview3.webp"
      alt=""
    />

    <img class="pcm-b-medal" src="@/assets/images/pc/pageB/medal.webp" alt="" />
    <img class="pcm-b-copy" src="@/assets/images/pc/pageB/copy.webp" alt="" />
    <img
      class="pcm-b-features"
      src="@/assets/images/pc/pageB/features.webp"
      alt=""
    />

    <div class="pcm-b-header">
      <img
        class="pcm-b-logo"
        src="@/assets/images/mobile1/pageB/logo.webp"
        alt=""
      />
      <div class="pcm-b-services">
        <img
          v-if="tgUrl"
          class="pcm-b-service"
          src="@/assets/images/mobile1/pageB/service-tg.webp"
          @click="toContact(tgUrl)"
          alt="官方群组"
        />
        <img
          v-if="qdUrl"
          class="pcm-b-service"
          src="@/assets/images/mobile1/pageB/service-qd.webp"
          @click="toContact(qdUrl)"
          alt="渠道合作"
        />
        <img
          v-if="swUrl"
          class="pcm-b-service"
          src="@/assets/images/mobile1/pageB/service-sw.webp"
          @click="toContact(swUrl)"
          alt="商务合作"
        />
      </div>
    </div>

    <img
      class="pcm-b-download pcm-b-download-android"
      src="@/assets/images/pc/pageB/download-android.webp"
      alt="安卓手机下载"
    />
    <img
      class="pcm-b-download pcm-b-download-ios"
      src="@/assets/images/pc/pageB/download-ios.webp"
      alt="苹果手机下载"
    />
    <div class="pcm-b-qr-panel">
      <img
        class="pcm-b-qr-panel-bg"
        src="@/assets/images/pc/pageB/qr-panel.webp"
        alt=""
      />
      <img class="pcm-b-qr" :src="qrImg" alt="下载二维码" />
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  props: ["qrImg", "configs", "version"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      activeIndex: 0,
      slideTimer: null,
      overlaySlides: [
        require("@/assets/images/pc/pageB/slide2.webp"),
        require("@/assets/images/pc/pageB/slide3.webp")
      ]
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1081,
        dw: 1920,
        el: "#pcm-b-wrapper",
        resize: true
      },
      false
    );
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
    autofit.off("#pcm-b-wrapper");
  },
  methods: {
    startRotation() {
      this.stopRotation();
      this.slideTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % 3;
      }, 3500);
    },
    stopRotation() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer);
        this.slideTimer = null;
      }
    },
    toContact(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-b-wrapper {
  width: 1920px;
  height: 1081px;
  overflow: hidden;
  position: relative;
  background: #000;

  .pcm-b-bg {
    width: 1920px;
    height: 1081px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    pointer-events: none;
  }

  .pcm-b-slide {
    position: absolute;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.8s ease;
    pointer-events: none;

    &.active {
      opacity: 1;
    }
  }

  .pcm-b-slide-2 {
    left: -86.56px;
    top: -49.64px;
    width: 948.28px;
    height: 1197.16px;
  }

  .pcm-b-slide-3 {
    left: -115.16px;
    top: -52.7px;
    width: 992.58px;
    height: 1213.17px;
  }

  .pcm-b-preview {
    position: absolute;
    z-index: 1;
    pointer-events: none;
  }

  .pcm-b-preview-1 {
    left: 690px;
    top: 37px;
    width: 386px;
    height: 217px;
  }

  .pcm-b-preview-2 {
    left: 1159px;
    top: 83px;
    width: 398px;
    height: 224px;
  }

  .pcm-b-preview-3 {
    left: 848px;
    top: 277px;
    width: 348px;
    height: 196px;
  }

  .pcm-b-medal {
    position: absolute;
    left: 36px;
    top: 131px;
    width: 229.9px;
    height: 255.26px;
    z-index: 5;
    pointer-events: none;
  }

  .pcm-b-copy {
    position: absolute;
    left: 874px;
    top: 114px;
    width: 963px;
    height: 521.68px;
    z-index: 3;
    pointer-events: none;
  }

  .pcm-b-features {
    position: absolute;
    left: 848px;
    top: 606px;
    width: 1008px;
    height: 156px;
    z-index: 3;
    pointer-events: none;
  }

  .pcm-b-header {
    position: absolute;
    left: 69px;
    right: 46px;
    top: 27px;
    height: 95px;
    z-index: 10;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .pcm-b-logo {
    width: 259.38px;
    height: 73.69px;
    margin-top: 10.56px;
  }

  .pcm-b-services {
    margin-top: -15px;
    display: flex;
    align-items: flex-end;
    gap: 48px;
  }

  .pcm-b-service {
    width: 68px;
    height: auto;
    cursor: pointer;
  }

  .pcm-b-download {
    position: absolute;
    left: 904px;
    width: 255.36px;
    height: 71.98px;
    z-index: 6;
    pointer-events: none;
  }

  .pcm-b-download-android {
    top: 785.3px;
  }

  .pcm-b-download-ios {
    top: 884.71px;
  }

  .pcm-b-qr-panel {
    position: absolute;
    left: 1186.77px;
    top: 778px;
    width: 650.49px;
    height: 185.99px;
    z-index: 6;
  }

  .pcm-b-qr-panel-bg {
    display: block;
    width: 650.49px;
    height: 185.99px;
  }

  .pcm-b-qr {
    position: absolute;
    left: 14.61px;
    top: 14.61px;
    width: 156.78px;
    height: 156.78px;
    border-radius: 12.66px;
    background: #fff;
  }
}
</style>
